import React, { useEffect, useRef } from 'react'

import Script from 'next/script'

import { Column } from 'Components/UI'

const SRC =
  'https://static.hsappstatic.net/MeetingsEmbed/ex/MeetingsEmbedCode.js'

function BookMeetingForm() {
  const containerRef = useRef<HTMLDivElement>(null)

  useEffect(() => {
    const container = containerRef.current
    if (!container) return

    container.innerHTML = ''

    document
      .querySelectorAll<HTMLScriptElement>('script[src^=SRC]')
      .forEach(script => script.remove())

    const script = document.createElement('script')
    script.src = `${SRC}?v=${Date.now()}`
    script.async = true
    document.body.appendChild(script)

    return () => {
      container.innerHTML = ''
    }
  }, [])

  return (
    <Column minHeight="600px">
      <div
        className="meetings-iframe-container"
        data-src="https://meetings-ap1.hubspot.com/emajin?embed=true"
        ref={containerRef}
        style={{ width: '100%', height: '100%' }}
      ></div>

      <Script src={SRC} type="text/javascript"></Script>
    </Column>
  )
}

export default BookMeetingForm
